import {
  Component , ElementRef ,
  Input ,
  OnChanges , OnDestroy , OnInit , ViewChild ,
} from '@angular/core';
import {FrontUserService} from "../../../../core/services/frontUsers.service";
import html2canvas from 'html2canvas';
import {NgxSpinnerService} from "ngx-spinner";
import * as domtoimage from 'dom-to-image';
@Component({
    selector: 'time-line',
    templateUrl: './time-line.component.html',
    styleUrls: ['./time-line.component.scss'],
    standalone: false
})
export class TimeLineComponent implements OnChanges , OnDestroy , OnInit {
  @Input()  timeLines;
  @ViewChild('screen') screen: ElementRef;
  @ViewChild('canvas') canvas: ElementRef;
  @ViewChild('downloadLink') downloadLink: ElementRef;
  constructor ( private usersService: FrontUserService, private spinner: NgxSpinnerService ) {}

  ngOnInit () {
  }


  ngOnChanges () {

  }


  ngOnDestroy () {

  }
  active(item) {
    this.usersService.activeTimeLog(item.id).subscribe((res) => {
      if (res) {
        item.active = true;
      }
    });
  }

  disactive(item) {
    this.usersService.disactiveTimeLog(item.id).subscribe((res) => {
      if (res) {
        item.active = false;
      }
    });
  }

  downloadImage(event){
    event.stopPropagation();
    html2canvas(this.screen.nativeElement, {  background: '#000000'}).then(canvas => {
      this.canvas.nativeElement.src = canvas.toDataURL();
      this.downloadLink.nativeElement.href = canvas.toDataURL('image/jpeg');
      this.downloadLink.nativeElement.download = 'marble-diagram.jpeg';
      this.downloadLink.nativeElement.click();
      this.spinner.hide();
    });
  }
}
